module.exports = __webpack_public_path__ + "img/icon6.98dc0188.png";